export function GetCurrentPageHandler(_: never, webchat: any) {
    webchat.sendMessage('', { success: true, url: window.location.href });
}
